export default __webpack_public_path__ + "static/media/pencil-dark-autumn.0d746705.png";